class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', onKeyUpEscape);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));

    if (this.mainDetailsToggle.classList.contains('mega-menu-container')) {
      this._closeTimer = null;

      // Prevent the default click→toggle (hover drives open/close
      // instead) and navigate to the menu item's URL when present.
      // The Liquid sets `data-href="{{ link.url }}"` on the summary
      // for top-level mega-menu items so a click on the trigger acts
      // like a real link.
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', (e) => {
        e.preventDefault();
        const href = e.currentTarget.dataset.href;
        if (href) {
          window.location.href = href;
        }
      });

      // Open on hover over the trigger
      this.addEventListener('mouseenter', () => {
        clearTimeout(this._closeTimer);
        this.mainDetailsToggle.setAttribute('open', '');
      });

      // Delayed close when leaving trigger — gives cursor time to reach the panel
      this.addEventListener('mouseleave', () => {
        this._closeTimer = setTimeout(() => this.close(), 80);
      });

      // Once open, also watch the absolutely-positioned panel directly
      this.mainDetailsToggle.addEventListener('toggle', () => {
        if (this.mainDetailsToggle.open) {
          const panel = this.mainDetailsToggle.querySelector('.mega-menu__content');
          if (panel && !panel._hoverBound) {
            panel._hoverBound = true;
            panel.addEventListener('mouseenter', () => clearTimeout(this._closeTimer));
            panel.addEventListener('mouseleave', () => {
              this._closeTimer = setTimeout(() => this.close(), 80);
            });
          }
        }
      });
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    if (this.mainDetailsToggle.classList.contains('mega-menu-container')) {
      const panel = this.mainDetailsToggle.querySelector('.mega-menu__content');
      if (panel && this.mainDetailsToggle.open) {
        panel.classList.add('is-closing');
        const onEnd = () => {
          panel.removeEventListener('animationend', onEnd);
          panel.classList.remove('is-closing');
          this.mainDetailsToggle.removeAttribute('open');
        };
        panel.addEventListener('animationend', onEnd);
        return;
      }
    }
    this.mainDetailsToggle.removeAttribute('open');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
